import { render, staticRenderFns } from "./KundendatenLieferung.vue?vue&type=template&id=2cd083e0"
import script from "./KundendatenLieferung.vue?vue&type=script&lang=ts"
export * from "./KundendatenLieferung.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports